import { Link as Scroll } from 'react-scroll'

const DURATION = 800

type Props = {
  jumpToId: string
  children: JSX.Element
  duration?: number
  offset?: number
}

export const TransitionInPage = ({
  jumpToId,
  children,
  duration = DURATION,
  offset = 0,
}: Props): JSX.Element => {
  return (
    <Scroll to={jumpToId} smooth offset={offset} duration={duration}>
      {children}
    </Scroll>
  )
}
